module.exports = __webpack_public_path__ + "static/The-Pinnacle-Logo-cc88112812860b21d5c6b66cf79cb00a.png";